module.exports = function() {
  return new Worker(__webpack_public_path__ + "384a74a4fa4e4d57a81a.worker.js");
};


// WEBPACK FOOTER //
// ./src/models/Telemetry.worker.js